<mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>
<div [ngClass]="{ zonaoculta: loading === true }">
  <app-buttons
    (save)="submit()"
    (close)="destroy()"
    (discard)="discard()"
    [buttonsWrap]="'panel'"
    [modificar]="modificar"
  ></app-buttons>
  <div class="editor-registro">
    <div class="divForm">
      <form [formGroup]="editTemporadaForm" (ngSubmit)="submit()">
        <div class="temporada-form">
          <section class="section-card">
            <div class="section-header">
              <h3 class="section-title">
                {{ translation?.InfoTemporada || 'Información de la temporada' }}
              </h3>
            </div>

            <div class="section-grid section-grid--basic">
              <mat-form-field appearance="outline">
                <mat-label>{{ translation?.Nombre || 'Nombre' }}</mat-label>
                <input matInput formControlName="Nombre" maxlength="100" />
                <mat-error *ngIf="validateFields('Nombre')">
                  {{ getErrorMessage("Nombre") }}
                </mat-error>
              </mat-form-field>

              <mat-form-field appearance="outline" class="descripcion-field">
                <mat-label>{{ translation?.Descripcion || 'Descripción' }}</mat-label>
                <textarea
                  matInput
                  formControlName="Descripcion"
                  rows="2"
                  maxlength="500"
                  (input)="onDescripcionInput($event)"
                ></textarea>
                <mat-hint align="end">
                  {{ (editTemporadaForm.get('Descripcion')?.value?.length || 0) }}/500
                </mat-hint>
                <mat-error *ngIf="validateFields('Descripcion')">
                  {{ getErrorMessage("Descripcion") }}
                </mat-error>
              </mat-form-field>

              <mat-form-field
                *ngIf="mode === 'U'"
                appearance="outline"
                class="descripcion-field"
              >
                <mat-label>
                  {{ motivoModificacionEsObligatorio ? "* " : "" }}{{
                    translation?.MotivoModificacion || "Motivo de la modificación"
                  }}
                </mat-label>
                <textarea
                  matInput
                  formControlName="MotivoModificacion"
                  rows="2"
                  maxlength="500"
                  (input)="onMotivoModificacionInput($event)"
                ></textarea>
                <mat-hint align="end">
                  {{ (editTemporadaForm.get('MotivoModificacion')?.value?.length || 0) }}/500
                </mat-hint>
                <mat-error *ngIf="validateFields('MotivoModificacion')">
                  {{ getErrorMessage("MotivoModificacion") }}
                </mat-error>
              </mat-form-field>
            </div>
          </section>

          <section class="section-card">
            <div class="section-header">
              <h3 class="section-title">{{ translation?.Configuracion || 'Configuración' }}</h3>
            </div>

            <div class="section-grid section-grid--config">
              <mat-form-field appearance="outline" class="color-field">
                <mat-label>{{ translation?.Color || 'Color' }}</mat-label>
                <div class="color-input-row">
                  <input
                    type="color"
                    [value]="colorParaCalendario"
                    (input)="onColorPickerChange($event)"
                    (mousedown)="onColorPickerMouseDown($event)"
                    (mouseup)="onColorPickerMouseUp($event)"
                    (mouseleave)="onColorPickerMouseUp($event)"
                    class="color-picker-input"
                  />
                  <mat-select
                    [value]="colorSelectValue"
                    (selectionChange)="onColorSelectChange($event.value)"
                  >
                    <mat-option *ngFor="let c of coresDisponiveisOrdenadas" [value]="c.value">
                      {{ paletteLabel(c) }}
                    </mat-option>
                    <mat-option [value]="'__custom__'">
                      {{ translation?.Personalizada || 'Personalizada' }}
                    </mat-option>
                  </mat-select>
                </div>
                <mat-hint *ngIf="isCustomColor">
                  {{ translation?.ColorCustomHint || 'Color personalizado (hex)' }}
                </mat-hint>
              </mat-form-field>

              <mat-form-field *ngIf="isCustomColor" appearance="outline" class="color-field">
                <mat-label>{{ translation?.Color || 'Color' }}</mat-label>
                <input
                  matInput
                  formControlName="Color"
                  [placeholder]="translation?.ColorHexPlaceholder || '#RRGGBB'"
                  maxlength="9"
                  (input)="onHexColorInput($event)"
                />
                <mat-error *ngIf="validateFields('Color')">
                  {{ getErrorMessage("Color") }}
                </mat-error>
              </mat-form-field>

              <div class="toggles">
                <div class="toggle-item">
                  <span class="toggle-label">{{ translation?.Activa || 'Activa' }}</span>
                  <mat-slide-toggle formControlName="Activa"></mat-slide-toggle>
                </div>
                <div class="toggle-item">
                  <span class="toggle-label">{{ translation?.PorDefecto || 'Por defecto' }}</span>
                  <mat-slide-toggle formControlName="PorDefecto"></mat-slide-toggle>
                </div>
              </div>
            </div>
          </section>

          <section class="section-card fechas-wrapper">
          <div class="fechas-header">
            <h3 class="fechas-title">
              {{ translation?.SelectorFechasTemporada || 'Selector de fechas' }}
            </h3>
          </div>
          <div class="form-group fechas-section">
            <mat-form-field appearance="outline">
              <mat-label>{{ translation?.FechaInicio || 'Fecha Inicio' }}</mat-label>
              <input
                matInput
                [matDatepicker]="pickerInicio"
                formControlName="FechaInicio"
                [min]="minFechaInicioPicker"
                [max]="maxFechaInicioPicker"
              />
              <mat-datepicker-toggle matSuffix [for]="pickerInicio"></mat-datepicker-toggle>
              <mat-datepicker
                #pickerInicio
                [startAt]="startAtInicioPicker"
                startView="month"
                panelClass="limited-years-panel"
                [calendarHeaderComponent]="filterCalendarHeader"
              ></mat-datepicker>
              <mat-error *ngIf="validateFields('FechaInicio')">
                {{ getErrorMessage("FechaInicio") }}
              </mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>{{ translation?.FechaFin || 'Fecha Fin' }}</mat-label>
              <input
                matInput
                [matDatepicker]="pickerFin"
                formControlName="FechaFin"
                [min]="minFechaFinPicker"
                [max]="maxFechaFinPicker"
              />
              <mat-datepicker-toggle matSuffix [for]="pickerFin"></mat-datepicker-toggle>
              <mat-datepicker
                #pickerFin
                [startAt]="startAtFinPicker"
                startView="month"
                panelClass="limited-years-panel"
                [calendarHeaderComponent]="filterCalendarHeader"
              ></mat-datepicker>
              <mat-error *ngIf="validateFields('FechaFin')">
                {{ getErrorMessage("FechaFin") }}
              </mat-error>
            </mat-form-field>
          </div>
          </section>

          <section class="section-card meses-calendarios" #calendariosRoot>
          <h3 class="selector-title">{{ translation?.SelectorMeses || 'Selector de meses de la temporada' }}</h3>
          <p class="instrucao-checkbox-calendario">
            {{ translation?.InstrucaoCheckboxCalendario || 'Casillas: marque para mostrar el mes abajo; desmarque para ocultar. En los calendarios: haga clic en un día para seleccionar; mantenga pulsado el botón izquierdo del ratón y arrastre para marcar varios días.' }}
          </p>
          <div class="meses-checkboxes-row">
            <mat-checkbox
              *ngFor="let m of getMesesParaExibir(); trackBy: trackByMesKey"
              [formControl]="getMesVisControl(m.mes)"
              class="mes-checkbox"
            >
              {{ m.label }}
            </mat-checkbox>
          </div>
          <p class="hint" *ngIf="loadingOcupados || loadingPreviewTemporadas">{{
            translation?.TemporadaCalendarioCargando || translation?.Cargando || 'Cargando...'
          }}</p>
          <h4 class="dias-title">{{ translation?.Dias || 'Días' }}</h4>
          <div
            class="calendarios-grid"
          >
            <div *ngFor="let m of getMesesCalendarioVisibles(); trackBy: trackByMesKey" class="calendario-card" [class.desactivado]="isMesCalendarioAtenuado(m.mes)">
              <div class="calendario-header">{{ m.label }}</div>
              <div class="calendario-body">
                <div class="dias-semana">
                  <span *ngFor="let d of cabeceraDiasSemanaCalendario">{{ d }}</span>
                </div>
                <div class="dias-grid">
                  <ng-container *ngFor="let _ of [].constructor(getDiaOffset(m.mes))">
                    <span class="dia-vacio"></span>
                  </ng-container>
                  <button
                    *ngFor="let d of getDiasDelMes(m.mes); trackBy: trackByDiaKey"
                    type="button"
                    class="dia-btn"
                    [class.selected]="isDiaSeleccionado(m.mes, d)"
                    [class.occupied]="isDiaOcupado(m.mes, d) && !mostrarPreviewColor(m.mes, d)"
                    [class.temporada-existe-preview]="mostrarPreviewColor(m.mes, d)"
                    [class.dia-preview--p1]="getPreviewVarianteSwatchParaDia(m.mes, d) === 1"
                    [class.dia-preview--p2]="getPreviewVarianteSwatchParaDia(m.mes, d) === 2"
                    [class.dia-preview--p3]="getPreviewVarianteSwatchParaDia(m.mes, d) === 3"
                    [class.dia-preview--p4]="getPreviewVarianteSwatchParaDia(m.mes, d) === 4"
                    [class.dia-preview--p5]="getPreviewVarianteSwatchParaDia(m.mes, d) === 5"
                    [class.dia-btn-disabled]="!isDiaSeleccionado(m.mes, d) && (isDiaOcupado(m.mes, d) || !isDiaDentroDelRango(m.mes, d)) && !mostrarPreviewColor(m.mes, d)"
                    [style.--preview-color]="mostrarPreviewColor(m.mes, d) ? getPreviewColorCss(m.mes, d) : null"
                    [matTooltip]="getPreviewTooltipParaDia(m.mes, d)"
                    [matTooltipDisabled]="!mostrarPreviewColor(m.mes, d)"
                    matTooltipShowDelay="200"
                    [attr.aria-label]="getPreviewAriaLabelDia(m.mes, d)"
                    [disabled]="!isDiaSeleccionado(m.mes, d) && (isDiaBloqueadoParaSeleccion(m.mes, d) || !isDiaDentroDelRango(m.mes, d))"
                    [attr.aria-disabled]="(isDiaBloqueadoParaSeleccion(m.mes, d) || !isDiaDentroDelRango(m.mes, d)) ? 'true' : null"
                    (click)="onDiaClick(m.mes, d)"
                    (pointerdown)="onDiaPointerDown(m.mes, d)"
                    (pointerenter)="onDiaMouseEnter(m.mes, d)"
                  >
                    <span class="dia-btn-stack">
                      <span class="dia-numero">{{ d }}</span>
                    </span>
                    <mat-icon
                      *ngIf="mostrarPreviewPorDefecto(m.mes, d)"
                      class="dia-preview-star"
                      [style.color]="getPreviewStarColorCss(m.mes, d)"
                      [class.dia-preview-star--clara]="previewStarEsBlanca(m.mes, d)"
                      aria-hidden="true"
                    >star</mat-icon>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div
            class="leyenda-temporadas"
            *ngIf="usaVistaPreviaCalendario() && previewLeyendaFuente.length && !loadingPreviewTemporadas"
          >
            <h3 class="leyenda-section-title">
              {{
                translation?.LeyendaVistaCalendarioTitulo ||
                  translation?.LeyendaTemporadasTitulo ||
                  'Leyenda del calendario'
              }}
            </h3>
            <p class="leyenda-vacia" *ngIf="previewLeyendaFuente.length && !previewLeyenda.length">
              {{ translation?.LeyendaVistaCalendarioNingunaEnVista || 'Ninguno en la vista.' }}
            </p>
            <ul class="leyenda-lista" *ngIf="previewLeyenda.length" role="list">
              <li
                *ngFor="let it of previewLeyenda; trackBy: trackByLeyendaPk"
                class="leyenda-item"
                [matTooltip]="getLeyendaTooltipItem(it)"
                matTooltipShowDelay="200"
              >
                <span
                  class="leyenda-swatch"
                  [style.background-color]="it.colorCss"
                  [class.leyenda-swatch--p1]="it.leyendaVarianteSwatch === 1"
                  [class.leyenda-swatch--p2]="it.leyendaVarianteSwatch === 2"
                  [class.leyenda-swatch--p3]="it.leyendaVarianteSwatch === 3"
                  [class.leyenda-swatch--p4]="it.leyendaVarianteSwatch === 4"
                  [class.leyenda-swatch--p5]="it.leyendaVarianteSwatch === 5"
                  aria-hidden="true"
                ></span>
                <span class="leyenda-texto">
                  <span class="leyenda-nombre">{{ it.nombre }}</span>
                </span>
              </li>
            </ul>
            <div class="leyenda-por-defecto-nota">
              <mat-icon class="leyenda-por-defecto-star" aria-hidden="true">star</mat-icon>
              <span>{{ translation?.PorDefecto || 'Por Defecto' }}</span>
            </div>
          </div>
          </section>

          <section class="section-card centros-section">
            <div class="section-header">
              <h3 class="section-title">{{ translation?.Centros || 'Centros' }}</h3>
            </div>

            <customan-dual-list
              [source]="centrosSinAsignar"
              [(destination)]="centrosAsignados"
              key="pkId"
              display="Nombre"
              [format]="format"
              [filter]="true"
            >
            </customan-dual-list>
          </section>
        </div>
      </form>
    </div>
  </div>
</div>
